import { Currency } from "./currency.type";

export enum TaskOrderStatus {
  Pending = "В ожидании",        // Заказ создан, ожидает подтверждения
  InProgress = "В процессе",     // Заказ подтвержден, в работе
  Rejected = "Отказ",           // Заказ отклонен
  OnHold = "В стопе",           // Заказ приостановлен
  Completed = "Выполнено",       // Заказ полностью выполнен
}

export interface ITaskOrder {
  _id: string;
  
  // Основная информация
  admissionDate: string;                    // Дата приема заказа
  produceId: string;                       // ID продукции
  produceName: string;                     // Название продукции
  total: number;                           // Общее количество
  clientId: string;                        // ID клиента
  clientName: string;                      // Название клиента
  description: string;                     // Описание заказа
  
  // Финансовая информация
  price: number;                           // Цена за единицу
  currency: Currency;                      // Валюта
  discount: number;                        // Скидка в процентах
  totalCost: number;                       // Общая стоимость
  
  // Системная информация
  orderNumber?: number;                    // Порядковый номер заказа (для сортировки и отображения)
  status: TaskOrderStatus;                 // Статус заказа
  priority: number;                        // Приоритет (0 = высший)
  ownerId: string;                         // ID создателя
  ownerName: string;                       // Имя создателя
  
  // Прогресс выполнения
  produced: number;                        // Произведено
  delivered: number;                       // Выдано клиенту
  productionProgress: number;              // Процент производства (0-100)
  deliveryProgress: number;                // Процент выдачи (0-100)
  
  // Дополнительная информация
  rejectReason?: string;                   // Причина отказа (если статус = Rejected)
  whatsappNumber?: string;                 // Номер WhatsApp для уведомлений
  
  // Временные метки
  createdAt: string;                       // Дата создания
  updatedAt: string;                       // Дата обновления
}
